module.exports = __webpack_public_path__ + "static/gothamhtf-book-1f8f27127040912101454d1b174eb306.woff";